"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const BackButton_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/BackButton.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const Tabs_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Tabs.vue"));
const BoxPlot_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BoxPlot.vue"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
function uniq(a) {
    return a.sort().filter(function (item, pos, ary) {
        return !pos || item != ary[pos - 1];
    });
}
let DensityTool = class DensityTool extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.filtered_metrics = this.metrics;
        this.metric_types = ['ALL', ...uniq(this.metrics.map(m => m.type_code + ''))];
        this.selected_metric_type = this.metric_types[0];
        this.selected_metric = this.metrics.length ? this.metrics[0] : null;
        this.plots = null;
        this.fetching = true;
    }
    mounted() {
        this.onChangeMetric();
    }
    get totalSamples() {
        if (!this.plots)
            return 0;
        return this.plots.reduce(function (prev, curr) {
            return prev + curr.cluster.samples.length;
        }, 0);
    }
    get totalParcels() {
        if (!this.plots)
            return 0;
        const parcels = {};
        this.plots.forEach(p => p.cluster.samples.forEach(s => {
            if (!s.parcel)
                return;
            parcels[s.parcel.id] = true;
        }));
        return Object.keys(parcels).length;
    }
    toClusterEdition() {
        this.$emit('to-cluster');
    }
    onChangeMetricType() {
        let metrics = this.metrics;
        if (this.selected_metric_type !== 'ALL') {
            metrics = metrics.filter(m => m.type_code === this.selected_metric_type);
        }
        this.filtered_metrics = metrics;
        this.selected_metric = metrics.length ? metrics[0] : null;
    }
    async onChangeMetric() {
        await (0, sleep_1.default)(100);
        if (!this.selected_metric) {
            this.fetching = false;
            return;
        }
        this.fetching = true;
        const plots = await this.density.compare(this.selected_metric);
        this.plots = plots.reverse();
        this.fetching = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DensityTool.prototype, "density", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DensityTool.prototype, "metrics", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('selected_metric_type')
], DensityTool.prototype, "onChangeMetricType", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('selected_metric')
], DensityTool.prototype, "onChangeMetric", null);
DensityTool = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BackButton: BackButton_vue_1.default,
            Loader: Loader_vue_1.default,
            Tabs: Tabs_vue_1.default,
            BoxPlot: BoxPlot_vue_1.default
        }
    })
], DensityTool);
exports.default = DensityTool;
